(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-geo-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-product')) {
    class CroProduct extends HTMLElement {
      #variants = [];
      #observer = null;
      connectedCallback() {
        const data = this.querySelector('[data-variants]');
        if (!data) return;
        try { this.#variants = JSON.parse(data.textContent); } catch (error) { console.error('Variant data could not be read.', error); return; }
        this.classList.add('is-enhanced');
        for (const input of this.querySelectorAll('[data-option-select]')) input.addEventListener('change', () => this.#updateVariant());
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.#changeQuantity(-1));
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.#changeQuantity(1));
        this.querySelector('[data-quantity]')?.addEventListener('input', () => this.#updateSubtotal());
        for (const button of this.querySelectorAll('[role="tab"]')) button.addEventListener('click', () => this.#selectTab(button));
        this.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => this.#moveTab(event));
        for (const button of this.querySelectorAll('[data-mobile-content-open]')) button.addEventListener('click', () => this.#openMobileContent(button));
        this.querySelector('[data-mobile-content-close]')?.addEventListener('click', () => this.#closeMobileContent());
        this.querySelector('[data-mobile-content-dialog]')?.addEventListener('close', () => this.querySelector('[data-mobile-content-body]')?.replaceChildren());
        for (const button of this.querySelectorAll('[data-media-button]')) button.addEventListener('click', () => this.#showMedia(Number(button.dataset.mediaTargetIndex)));
        this.querySelector('[data-media-previous]')?.addEventListener('click', () => this.#stepMedia(-1));
        this.querySelector('[data-media-next]')?.addEventListener('click', () => this.#stepMedia(1));
        this.querySelector('[data-thumbnail-previous]')?.addEventListener('click', () => this.#stepMedia(-1));
        this.querySelector('[data-thumbnail-next]')?.addEventListener('click', () => this.#stepMedia(1));
        this.#setupSticky();
      }
      disconnectedCallback() { this.#observer?.disconnect(); }
      #selectedOptions() { return Array.from(this.querySelectorAll('[data-option-position]')).map((option) => option.querySelector('[data-option-select]')?.value); }
      #updateVariant() {
        const selected = this.#selectedOptions();
        const variant = this.#variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
        for (const option of this.querySelectorAll('[data-option-position]')) { const label = option.querySelector('[data-selected-option]'); if (label) label.textContent = option.querySelector('[data-option-select]')?.value || ''; }
        if (!variant) { this.#setUnavailable(); return; }
        this.querySelector('[data-variant-id]').value = variant.id;
        const question = this.querySelector('[data-product-question]');
        if (question) question.href = 'mailto:support@auvielight.com?subject=' + encodeURIComponent('Product question: ' + this.querySelector('h1').textContent.trim()) + '&body=' + encodeURIComponent('Product: ' + window.location.origin + window.location.pathname + '?variant=' + variant.id + '\nSelected option: ' + variant.title + '\nSKU: ' + (variant.sku || '') + '\nDestination country: \nMy question: ');
        const price = this.#money(variant.price);
        this.querySelector('[data-price]').textContent = price;
        this.querySelector('[data-price]').setAttribute('aria-label', this.dataset.priceLabel.replace('__PRICE__', price));
        this.querySelector('[data-sticky-price]').textContent = price;
        const compare = this.querySelector('[data-compare-price]');
        compare.hidden = !(this.dataset.verifiedSale === 'true' && variant.compare_at_price > variant.price);
        if (!compare.hidden) { const comparePrice = this.#money(variant.compare_at_price); compare.textContent = comparePrice; compare.setAttribute('aria-label', this.dataset.comparePriceLabel.replace('__PRICE__', comparePrice)); }
        const sku = this.querySelector('[data-sku]');
        if (sku) { sku.hidden = !variant.sku; sku.textContent = variant.sku ? `SKU: ${variant.sku}` : ''; }
        const availability = variant.available ? this.dataset.inStock : this.dataset.outOfStock;
        this.querySelector('[data-availability]').textContent = availability;
        const metaAvailability = this.querySelector('[data-meta-availability]');
        if (metaAvailability) metaAvailability.textContent = variant.available ? 'In stock' : 'Out of stock';
        this.#setButtons(variant.available);
        if (variant.featured_media?.id) { const button = this.querySelector(`[data-media-button="${CSS.escape(String(variant.featured_media.id))}"]`); if (button) this.#showMedia(Number(button.dataset.mediaTargetIndex)); }
        this.#updateSubtotal();
        this.#announce((this.dataset.selectionMessage || '').replace('__VARIANT__', variant.public_title || variant.title).replace('__PRICE__', price).replace('__AVAILABILITY__', availability));
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      }
      #setUnavailable() { this.#setButtons(false, true); this.querySelector('[data-availability]').textContent = this.dataset.unavailable; const metaAvailability = this.querySelector('[data-meta-availability]'); if (metaAvailability) metaAvailability.textContent = this.dataset.unavailable; }
      #setButtons(available, unavailable = false) { const label = unavailable ? this.dataset.unavailable : available ? this.dataset.addToCart : this.dataset.soldOut; for (const button of this.querySelectorAll('[data-add-button],[data-sticky-add]')) { button.disabled = !available; const target = button.querySelector('[data-add-label]'); if (target) target.textContent = label; else button.textContent = label; } }
      #money(cents) { return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100) + ' ' + this.dataset.currency; }
      #changeQuantity(delta) { const input = this.querySelector('[data-quantity]'); input.value = Math.max(1, Number(input.value || 1) + delta); this.#updateSubtotal(); }
      #updateSubtotal() { const variant = this.#variants.find((item) => String(item.id) === this.querySelector('[data-variant-id]').value); const quantity = Math.max(1, Number(this.querySelector('[data-quantity]')?.value || 1)); if (variant) this.querySelector('[data-subtotal]').textContent = this.#money(variant.price * quantity); }
      #selectTab(button) { for (const tab of this.querySelectorAll('[role="tab"]')) { const active = tab === button; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`); if (panel) panel.hidden = !active; } }
      #moveTab(event) { if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return; event.preventDefault(); const tabs = Array.from(this.querySelectorAll('[role="tab"]')); const current = tabs.indexOf(document.activeElement); let next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; tabs[next].focus(); this.#selectTab(tabs[next]); }
      #openMobileContent(trigger) {
        const dialog = this.querySelector('[data-mobile-content-dialog]');
        const body = this.querySelector('[data-mobile-content-body]');
        const title = this.querySelector('[data-mobile-content-title]');
        const source = this.querySelector(`#${CSS.escape(trigger.dataset.mobileContentTarget || '')}`);
        if (!dialog || !body || !title || !source) return;
        body.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
        title.textContent = trigger.textContent.trim();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }
      #closeMobileContent() {
        const dialog = this.querySelector('[data-mobile-content-dialog]');
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }
      #showMedia(index) { const media = this.querySelector(`[data-media-index="${index}"]`); if (!media) return; for (const item of this.querySelectorAll('[data-media-index]')) item.hidden = item !== media; const rail = this.querySelector('[data-thumbnail-rail]'); for (const thumbnail of this.querySelectorAll('[data-media-target-index]')) { const active = Number(thumbnail.dataset.mediaTargetIndex) === index; thumbnail.setAttribute('aria-current', String(active)); if (active && rail) rail.scrollTo({ left: thumbnail.offsetLeft - rail.offsetLeft, behavior: 'smooth' }); } }
      #stepMedia(direction) { const thumbnails = Array.from(this.querySelectorAll('[data-media-target-index]')); if (thumbnails.length === 0) return; const current = thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true'); this.#showMedia((current + direction + thumbnails.length) % thumbnails.length); }
      #setupSticky() { const form = this.querySelector('.cro-product__form'); const sticky = this.querySelector('[data-sticky]'); if (!form || !sticky || !('IntersectionObserver' in window)) return; this.#observer = new IntersectionObserver((entries) => { for (const entry of entries) sticky.classList.toggle('is-visible', !entry.isIntersecting); }, { threshold: .05 }); this.#observer.observe(form); }
      #announce(message) { const live = this.querySelector('[data-live]'); if (!live) return; live.textContent = ''; requestAnimationFrame(() => { live.textContent = message; }); }
    }
    customElements.define('cro-product', CroProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxury-recently-viewed')) {
    class LuxuryRecentlyViewed extends HTMLElement {
      static storageKey = 'formadesk_recent_products_v1';

      connectedCallback() {
        const current = this.readCurrentProduct();
        const stored = this.readStoredProducts();
        const previous = stored.filter((item) => !current || String(item.id) !== String(current.id));
        const visible = (previous.length ? previous : current ? [current] : stored).slice(0, Number(this.dataset.limit || 8));
        if (visible.length) {
          this.render(visible);
          this.hidden = false;
          this.setupCarousel();
        }
        if (current) this.storeCurrentProduct(current, stored);
      }

      readCurrentProduct() {
        const data = this.querySelector('[data-current-product]');
        if (!data) return null;
        try { return JSON.parse(data.textContent); } catch (error) { return null; }
      }

      readStoredProducts() {
        try {
          const value = JSON.parse(localStorage.getItem(LuxuryRecentlyViewed.storageKey) || '[]');
          return Array.isArray(value) ? value : [];
        } catch (error) { return []; }
      }

      storeCurrentProduct(current, stored) {
        try {
          const next = [current, ...stored.filter((item) => String(item.id) !== String(current.id))].slice(0, 12);
          localStorage.setItem(LuxuryRecentlyViewed.storageKey, JSON.stringify(next));
        } catch (error) { console.error('Recently viewed products could not be saved.', error); }
      }

      safeProductUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return url.origin === window.location.origin ? `${url.pathname}${url.search}` : '#';
        } catch (error) { return '#'; }
      }

      safeImageUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
        } catch (error) { return ''; }
      }

      render(products) {
        const list = this.querySelector('[data-recently-viewed-list]');
        const template = this.querySelector('[data-card-template]');
        if (!list || !template) return;
        const fragment = document.createDocumentFragment();
        for (const product of products) {
          const card = template.content.firstElementChild.cloneNode(true);
          const url = this.safeProductUrl(product.url);
          for (const link of card.querySelectorAll('[data-product-link]')) link.href = url;
          const image = card.querySelector('[data-product-image]');
          image.src = this.safeImageUrl(product.image);
          image.alt = product.imageAlt || product.title || '';
          card.querySelector('[data-product-title]').textContent = product.title || '';
          card.querySelector('[data-product-price]').textContent = product.price || '';
          card.querySelector('[data-product-compare-price]').textContent = product.verifiedSale === true ? (product.comparePrice || '') : '';
          card.querySelector('[data-product-type]').textContent = product.type || '';
          fragment.append(card);
        }
        list.append(fragment);
      }

      setupCarousel() {
        const viewport = this.querySelector('[data-carousel-viewport]');
        const previous = this.querySelector('[data-carousel-previous]');
        const next = this.querySelector('[data-carousel-next]');
        if (!viewport || !previous || !next) return;
        const update = () => {
          previous.disabled = viewport.scrollLeft <= 2;
          next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
        };
        previous.addEventListener('click', () => viewport.scrollBy({ left: -viewport.clientWidth * .9, behavior: 'smooth' }));
        next.addEventListener('click', () => viewport.scrollBy({ left: viewport.clientWidth * .9, behavior: 'smooth' }));
        viewport.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(viewport);
        update();
      }
    }
    customElements.define('luxury-recently-viewed', LuxuryRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxury-related-products')) {
    class LuxuryRelatedProducts extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-recommendations-content]')) {
          this.setupCarousel();
          return;
        }
        if (this.querySelector('[data-fallback-content]')) this.setupCarousel();
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.loadRecommendations();
        }, { rootMargin: '0px 0px 300px 0px' });
        observer.observe(this);
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const documentHtml = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = documentHtml.querySelector('luxury-related-products [data-recommendations-content]');
          if (!source) return;
          this.replaceChildren(source.cloneNode(true));
          this.setupCarousel();
        } catch (error) {
          console.error('Related products could not be loaded.', error);
        }
      }

      setupCarousel() {
        const viewport = this.querySelector('[data-carousel-viewport]');
        const previous = this.querySelector('[data-carousel-previous]');
        const next = this.querySelector('[data-carousel-next]');
        if (!viewport || !previous || !next) return;
        const update = () => {
          previous.disabled = viewport.scrollLeft <= 2;
          next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
        };
        previous.addEventListener('click', () => viewport.scrollBy({ left: -viewport.clientWidth * .9, behavior: 'smooth' }));
        next.addEventListener('click', () => viewport.scrollBy({ left: viewport.clientWidth * .9, behavior: 'smooth' }));
        viewport.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(viewport);
        update();
      }
    }
    customElements.define('luxury-related-products', LuxuryRelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='1';const dialog=root.querySelector('.lcp-dialog');root.querySelector('[data-open-filter]')?.addEventListener('click',()=>dialog?.showModal());dialog?.querySelector('[data-close-filter]')?.addEventListener('click',()=>dialog.close());dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});root.querySelector('[data-sort]')?.addEventListener('change',event=>{const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');location.assign(url)});root.querySelectorAll('[data-cols]').forEach(button=>button.addEventListener('click',()=>{const grid=root.querySelector('.lcp__grid');if(!grid)return;grid.dataset.columns=button.dataset.cols;root.querySelectorAll('[data-cols]').forEach(item=>item.classList.toggle('is-active',item===button))}))};document.querySelectorAll('.lcp').forEach(init);document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('.lcp')))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-menu-accordions')) {
    class FooterMenuAccordions extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 768px)');
        this.accordions = Array.from(this.querySelectorAll('[data-footer-accordion]'));
        this.handleMediaChange = () => this.syncState();
        this.media.addEventListener('change', this.handleMediaChange);
        for (const accordion of this.accordions) {
          accordion.addEventListener('toggle', () => {
            if (!this.media.matches || !accordion.open) return;
            for (const sibling of this.accordions) {
              if (sibling !== accordion) sibling.open = false;
            }
          });
        }
        this.syncState();
      }

      disconnectedCallback() {
        this.media?.removeEventListener('change', this.handleMediaChange);
      }

      syncState() {
        for (const accordion of this.accordions) {
          accordion.open = !this.media.matches;
          const summary = accordion.querySelector('summary');
          if (summary) summary.tabIndex = this.media.matches ? 0 : -1;
        }
      }
    }

    customElements.define('footer-menu-accordions', FooterMenuAccordions);
  }

  } catch(e) { console.error(e); }
})();
})();
